<template>
  <div class="contaier" v-loading="loading">
     <div class="title" style="padding-top: 20px;display: flex;align-items: center;width: 100%;justify-content: center;">您的专属霍兰德职业兴趣测试报告已生成
          <el-button type="primary" @click="backHome" style="margin-left: 30px;">返回首页</el-button>
     </div>
     <div class="banner-time">生成于：{{info.create_time}}</div>
     <div class="main">
         <div class="base-fx pre-wrap">
 <!--          <div class="titles">{{info.TITLE}}</div> -->
           <div class="left-head">#你的测试类型#</div>
           <div class="left-body">{{info.typeName}}</div>
           <div class="huojieguo">
						<span class="huoclear"></span>
						<span>{{fanyi(info.typeName[0])}}</span>
						<span>-{{fanyi(info.typeName[1])}}</span>
						<span>-{{fanyi(info.typeName[2])}}</span>
					</div>
         </div>
     </div>
     <div class="main" id="main" style="width: 760px;height: 400px;background: #fdfdff;margin-top: 20px;border-radius: 10px 10px 40px 10px;
     box-shadow: 0 0.075rem 0.725rem 0.025rem rgba(183,186,207,0.18);">

     </div>

     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 127px;">社会型（S）</div>
          <div class="jianjie">
            喜欢与人交往、不断结交新的朋友、善言谈、愿意教导别人。关心社会问题、渴望发挥自己的社会作用。寻求广泛的人际关系，比较看重社会义务和社会道德。
          </div>
          <div class="jianjie">
            典型职业：喜欢要求与人打交道的工作，能够不断结交新的朋友，从事提供信息、启迪、帮助、培训、开发或治疗等事务，并具备相应能力。如:
							教育工作者（教师、教育行政人员），社会工作者（咨询人员、公关人员）。
          </div>
       </div>
     </div>

     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 127px;">企业型（E）</div>
          <div class="jianjie">
            追求权力、权威和物质财富，具有领导才能。喜欢竞争、敢冒风险、有野心、抱负。为人务实，习惯以利益得失，权利、地位、金钱等来衡量做事的价值，做事有较强的目的性。
          </div>
          <div class="jianjie">
            喜欢要求具备经营、管理、劝服、监督和领导才能，以实现机构、政治、社会及经济目标的工作，并具备相应的能力。如项目经理、销售人员，营销管理人员、政府官员、企业领导、法官、律师。
          </div>
       </div>
     </div>

     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 127px;">常规型（C）</div>
          <div class="jianjie">
						尊重权威和规章制度，喜欢按计划办事，细心、有条理，习惯接受他人的指挥和领导，自己不谋求领导职务。喜欢关注实际和细节情况，通常较为谨慎和保守，缺乏创造性，不喜欢冒险和竞争，富有自我牺牲精神。
          </div>
          <div class="jianjie">
            喜欢要求注意细节、精确度、有系统有条理，具有记录、归档、据特定要求或程序组织数据和文字信息的职业，并具备相应能力。如：秘书、办公室人员、记事员、会计、行政助理、图书馆管理员、出纳员、打字员、投资分析员。
          </div>
       </div>
     </div>

     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 127px;">实际型（R）</div>
          <div class="jianjie">
						愿意使用工具从事操作性工作，动手能力强，做事手脚灵活，动作协调。偏好于具体任务，不善言辞，做事保守，较为谦虚。缺乏社交能力，通常喜欢独立做事。
          </div>
          <div class="jianjie">
            喜欢使用工具、机器，需要基本操作技能的工作。对要求具备机械方面才能、体力或从事与物件、机器、工具、运动器材、植物、动物相关的职业有兴趣，并具备相应能力。如：技术性职业（计算机硬件人员、摄影师、制图员、机械装配工），技能性职业（木匠、厨师、技工、修理工、农民、一般劳动）。
          </div>
       </div>
     </div>

     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 127px;">调研型（I）</div>
          <div class="jianjie">
						思想家而非实干家,抽象思维能力强，求知欲强，肯动脑，善思考，不愿动手。喜欢独立的和富有创造性的工作。知识渊博，有学识才能，不善于领导他人。考虑问题理性，做事喜欢精确，喜欢逻辑分析和推理，不断探讨未知的领域。
          </div>
          <div class="jianjie">
            喜欢智力的、抽象的、分析的、独立的定向任务，要求具备智力或分析才能，并将其用于观察、估测、衡量、形成理论、最终解决问题的工作，并具备相应的能力。如科学研究人员、教师、工程师、电脑编程人员、医生、系统分析员。
          </div>
       </div>
     </div>

     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 127px;">艺术型（A）</div>
          <div class="jianjie">
						有创造力，乐于创造新颖、与众不同的成果，渴望表现自己的个性，实现自身的价值。做事理想化，追求完美，不重实际。具有一定的艺术才能和个性。善于表达、怀旧、心态较为复杂。
          </div>
          <div class="jianjie">
            喜欢的工作要求具备艺术修养、创造力、表达能力和直觉，并将其用于语言、行为、声音、颜色和形式的审美、思索和感受，具备相应的能力。不善于事务性工作。如艺术方面（演员、导演、艺术设计师、雕刻家、建筑师、摄影家、广告制作人），音乐方面（歌唱家、作曲家、乐队指挥），文学方面（小说家、诗人、剧作家）。
          </div>
       </div>
     </div>

     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 45px;">职业</div>
          <div class="jianjie">
            {{info.zhiye}}
          </div>
       </div>
     </div>
     <div class="main">
       <div class="base-fx pre-wrap">
          <div class="base-quota-title" style="width: 133px;">参考填报专业</div>
          <div class="jianjie">
            {{info.cankao}}
          </div>
       </div>
     </div>
  </div>
</template>

<script>
  import { lookHuolan } from "@/api/gw/ceping"
  import {
    mapGetters
  } from "vuex"
import * as echarts from "echarts";
  export default {
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
    },
    data(){
      return{
          loading:false,
          info:{},
          arr: [{
						id: "S",
						title: "社会型"
					},
					{
						id: "E",
						title: "企业型"
					},
					{
						id: "C",
						title: "常规性"
					},
					{
						id: "R",
						title: "实际型"
					},
					{
						id: "I",
						title: "调研型"
					},
					{
						id: "A",
						title: "艺术型"
					}
				],
        myChart:null,
      }
    },
    mounted(){
      console.log("login9")
      this.$store.dispatch("getUserInfo").then(res=>{
        if(res.role==1){
          this.$confirm('此测评为VIP专属功能，开通VIP才可以使用?', '提示', {
            confirmButtonText: '购买VIP',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              path: "/Home",
              query: {
                type: 3
              }
            })
          })
        }else{
            this.lookHuolan();
        }
      })
    },
    methods:{
      backHome(){
        this.$router.push({
          path:"/"
        })
      },
      fanyi(id) {
				let a = this.arr.find(r => r.id == id)
				return a.title;
			},
        lookHuolan(){
          this.loading = true
          lookHuolan({}).then(res=>{
            this.info = res.data || {}
            if(res.data){
              setTimeout(()=>{
                this.init();
              },500)
            }
          }).finally(()=>{
            this.loading = false
          })
        },
        init(){
          let info = {
            ...this.info
          };
          //初始化echarts实例
          this.myChart = echarts.init(document.getElementById("main"));
          let option = {
					title: {
						text: ''
					},
					tooltip: {
						trigger: 'axis'
					},
					radar: [{
						indicator: [{
								text: '调研型(I)',
								max: 25
							},
							{
								text: '艺术型(A)',
								max: 25
							},
							{
								text: '企业型(E)',
								max: 25
							},
							{
								text: '社会型(S)',
								max: 25
							},
							{
								text: '实际型(R)',
								max: 25
							},
							{
								text: '常规型(C)',
								max: 25
							}
						],
						radius: 150
					}],
					series: [{
						type: 'radar',
						tooltip: {
							trigger: 'item'
						},
						areaStyle: {},
						data: [{
							value: info.score,
							name: '结果'
						}]
					}]
				};
        this.myChart.setOption(option);
        },
    },
  }
</script>

<style lang="scss" scoped>
	.huojieguo {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 32rpx;
		margin-top: 30rpx;

		text {}

		.huoclear {
			width: 30rpx;
			height: 30rpx;
			border-radius: 50%;
			background: #1890ff;

			margin-right: 20rpx;
		}
	}
  .base-quota-title{
    color: rgb(51, 58, 80);
    font-size: 22px;
    font-weight: bold;
    position: relative;
    width: 92px;
    line-height: 0.5;
    border-bottom: 10px solid rgb(211, 223, 244);
  }
  .jianjie{
    color: #515151;
    font-size: 16px;
    line-height: 32px;
        margin-top: 20px;
        text-indent: 2em;
  }
.main{
  display: flex;
  align-items: center;
  margin: 0 auto;
  .base-fx{
    position: relative;
    box-shadow: 0 0.075rem 0.725rem 0.025rem rgba(183,186,207,.18);
    border-radius: 10px 10px 40px 10px;
    background-color: #fdfdff;
    border-bottom-right-radius: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 720px;
    margin: 0 auto;
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    .left-head{
      font-size: 14px;
      color: #6a6f92;
      margin-top: 20px;
    }
    .left-body{
      width: 100%;
      text-align: center;
      color:#f25754;
      font-size: 70px;
      font-weight: bold;
      margin-top:20px;
    }
    .titles{

    }
  }
}
@import './scss/info.scss';
.banner-time{
  color: #fff;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/appraisal/HollanderResult.vue